(function (Drupal, once) {
  Drupal.behaviors.webformRatings = {
    attach(context) {
      const elements = once('webformRatings', '.webform-submission-hc-rating-form', context);

      elements.forEach((el) => {
        // Inputs (may not exist in all forms, so guard)
        const yesInput = el.querySelector('#edit-was-helpful-1');
        const noInput  = el.querySelector('#edit-was-helpful-0');

        // Submit webform when "helpful: yes" is selected
        if (yesInput) {
          yesInput.addEventListener('change', function () {
            if (this.checked) {
              const form = el.matches('form') ? el : el.closest('form');
              if (form) form.submit();
            }
          });
        }

        // Hide the "was helpful" wrapper when "helpful: no" is selected
        if (noInput) {
          noInput.addEventListener('change', function () {
            if (this.checked) {
              const wrapper = document.getElementById('edit-was-helpful--wrapper');
              if (wrapper) wrapper.style.display = 'none';
            }
          });
        }
      });
    }
  };
})(Drupal, once);
